document.addEventListener("DOMContentLoaded", function () {
  // Function for handling toggle with smooth animation
  function toggleElement(element) {
    const isOpen = element.classList.contains("open");
    const initialHeight = element.dataset.initialHeight || element.offsetHeight; // Save the current height of the element

    if (!element.dataset.initialHeight) {
      // Save the initial height in a data attribute
      element.dataset.initialHeight = initialHeight;
    }

    if (isOpen) {
      // Closing animation
      element.style.height = element.scrollHeight + "px"; // Set to current height
      requestAnimationFrame(() => {
        element.style.transition = "height 0.3s ease";
        element.style.height = initialHeight + "px"; // Return to initial height
      });
    } else {
      // Opening animation
      element.style.height = initialHeight + "px"; // Start from the current height
      element.classList.add("open"); // Add open class to start transition
      requestAnimationFrame(() => {
        element.style.transition = "height 0.3s ease";
        element.style.height = element.scrollHeight + "px";
      });
    }

    // Reset styles after transition ends
    element.addEventListener(
      "transitionend",
      function transitionEndHandler() {
        element.style.transition = ""; // Clear transition style
        if (!isOpen) {
          element.style.height = "auto"; // Reset height to auto when opening
        } else {
          element.classList.remove("open"); // Remove open class when closing
          element.style.height = initialHeight + "px"; // Return to initial height
        }
        element.removeEventListener("transitionend", transitionEndHandler);
      },
      { once: true }
    );
  }

  // Check and handle click on facilities button if it exists
  const facilitiesButton = document.querySelector(".button--facilities");
  if (facilitiesButton) {
    facilitiesButton.addEventListener("click", function () {
      const facilitiesList = document.querySelector(".facilities__list");
      if (facilitiesList) {
        toggleElement(facilitiesList);
      }
    });
  }

  // Check and handle click on more button if it exists
  const moreButton = document.querySelector(".button--more");
  if (moreButton) {
    moreButton.addEventListener("click", function () {
      const moreDesc = document.querySelector(".more__desc");
      if (moreDesc) {
        toggleElement(moreDesc);
      }
    });
  }
});
